import { useGlobalStore } from '@/stores/global';
import type { App } from 'vue';

export default {
  install: (app: App) => {
    const globalStore = useGlobalStore();
    const { assets_url, assets_cdn_url } = globalStore;

    function assets(key: string) {
      return `${assets_url}/${key}`;
    }

    function avatar(
      key: string,
      size: 'card' | 'large' | 'medium' | 'mini' | 'small' | 'thumb' = 'card',
    ) {
      return `${assets_cdn_url}/users/avatar/${size}/${key}.jpg`;
    }

    app.config.globalProperties.$assets = assets;
    app.config.globalProperties.$avatar = avatar;
    app.provide('assets', assets);
    app.provide('avatar', avatar);
  },
};
